import { Slider } from '@alltrails/denali/components/Slider';
import useDraftValue from '../../hooks/useDraftValue';
import type { SliderFilterConfigV2 } from './types';

const SliderFilterControl = ({ filterConfig }: { filterConfig: SliderFilterConfigV2 }) => {
  const { onChange, onChangeEnd, value } = filterConfig.slider;
  const { draft, onChange: onDraftChange, onChangeEnd: onDraftChangeEnd } = useDraftValue(value, { onChange, onChangeEnd });

  return (
    <Slider
      {...filterConfig.slider}
      value={draft}
      onChange={onDraftChange}
      onChangeEnd={onDraftChangeEnd}
      headerValueTextVariant="text100"
      labelTextVariant="heading200"
    />
  );
};

export default SliderFilterControl;
